module.exports = __webpack_public_path__ + "static/img/course-banner.c4cfceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/course-banner.png
// module id = I18s
// module chunks = 63